import actions from '../../actions/LevelFundedBenefitsSets'
import { connectPlanSharedBusinessRules } from '../PlanSharedBusinessRules/CreateBusinessRulesShow'

export default connectPlanSharedBusinessRules('LevelFunded', actions.show.main, actions.show.reset)
